/* Skip the Production Line — tiered rush-production fee (owner 2026-08-10).
   PRODUCTION priority, not shipping: copy must always say "prints first",
   never promise delivery speed. One product, one SKU (PRIORITY-PROD),
   one variant per tier; the tier follows the TOTAL printed-unit count of
   the whole cart. Reconcile runs after every cart write via the fetch hook
   below, so adding more labels re-prices an existing fee upward even when
   the checkbox wasn't touched (anti-gaming); the fee is only ever removed
   by an explicit action (cart line removal / zero printed units). */
window.VARUSH = (function () {
  'use strict';
  var FEE_SKU = 'PRIORITY-PROD';
  var TIERS = [
    /* FLAT FEE, restored 2026-08-14 per owner: one price whatever the order
       size. The 8-rung ladder (49.99 / 79.99 / 119.99 / 179.99 / 259.99 /
       359.99 / 499.99) is retired -- those variants still exist in Shopify so
       the ladder can be restored by putting the rows back here. min:12 keeps
       the old behaviour of not offering the fee on a trivially small order.
       isFeeLine() also matches on the shared PRIORITY-PROD sku, so a cart
       still holding an old higher-tier fee line is detected and re-priced
       DOWN to this one rather than ending up with two fee lines. */
    /* SCALES AGAIN 2026-10-25 (owner: "skip the line printing needs to scale with the purchase up and minimal
       price at 9.99"). Rungs are WHOLE-CART printed labels and sit on the volume-discount rungs (60 / 240 /
       1,200 / 2,400 / 4,800 labels = 5 / 20 / 100 / 200 / 400 packs) plus 120. Same 8 variants as the old
       ladder, re-priced + renamed; prior prices in session scratchpad rush/variants_before_20261025.json. */
    { min: 12,   vid: 52766206886164, price: 10.99,  label: '12-59 labels' },
    { min: 60,   vid: 53620327514388, price: 15.99,  label: '60-119 labels' },
    { min: 120,  vid: 53620327645460, price: 20.99,  label: '120-239 labels' },
    { min: 240,  vid: 53620327710996, price: 30.99,  label: '240-599 labels' },
    { min: 600,  vid: 53620327776532, price: 50.99,  label: '600-1,199 labels' },
    { min: 1200, vid: 53620327842068, price: 80.99,  label: '1,200-2,399 labels' },
    { min: 2400, vid: 53620327907604, price: 120.99, label: '2,400-4,799 labels' },
    { min: 4800, vid: 53620327973140, price: 180.99, label: '4,800+ labels' }
  ];
  var FEE_VIDS = {};
  TIERS.forEach(function (t) { FEE_VIDS[t.vid] = 1; });

  /* printed units for one cart line. SKU contract (VialArt):
       LABEL-<N>-* / LABEL-UP-<N>-*  -> N per pack x line qty
       BULK-<N>                      -> N units x line qty
     The pack size is CAPTURED from the SKU, never assumed. 3 mL sells as
     LABEL-12-AUR (12 a pack) and 10 mL as LABEL-6-AUR-10ML (6 a pack), and one
     cart can hold both. While this read a literal 12, every 10 mL line counted
     as ZERO labels: no rush tier was offered, the 24-label minimum failed open,
     and the cart stats strip deleted itself.
     Everything else (fee itself, applicator, AI credits, redesign service)
     counts ZERO -- including VialCase's LABEL-VC-* lines, since this file ships
     to both themes. SKUs only — cart properties are customer-writable.
     MUST stay identical to unitsOf() in assets/va-cart-guard2.js. */
  function unitsOf(item) {
    if (!item) return 0;
    if (typeof item.units === 'number') return Math.max(0, item.units);
    var sku = String(item.sku || '').toUpperCase();
    var qty = Math.max(1, parseInt(item.quantity, 10) || 1);
    if (sku.indexOf(FEE_SKU) === 0) return 0;
    var m = /^BULK-(\d+)/.exec(sku);
    if (m) return parseInt(m[1], 10) * qty;
    m = /^LABEL(?:-UP)?-(\d+)(?:-|$)/.exec(sku);
    if (m) return (parseInt(m[1], 10) || 0) * qty;
    return 0;
  }

  function isFeeLine(item) {
    if (!item) return false;
    if (String(item.sku || '').toUpperCase().indexOf(FEE_SKU) === 0) return true;
    return !!FEE_VIDS[Number(item.variant_id || item.id)];
  }

  function tierFor(units) {
    if (!units || units < TIERS[0].min) return null;
    var t = null;
    for (var i = 0; i < TIERS.length; i++) if (units >= TIERS[i].min) t = TIERS[i];
    return t;
  }

  /* PURE: no DOM, no network.
     cartItems: [{sku, quantity, variant_id, key}] — the live cart
     itemsBeingAdded: same shape (or {units:N}) — not yet in the cart
     wantRush: the surface's checkbox state
     -> {addVariantId|null, removeLineKey|null} */
  function rushPlan(cartItems, itemsBeingAdded, wantRush) {
    cartItems = cartItems || []; itemsBeingAdded = itemsBeingAdded || [];
    var units = 0, i, feeLine = null;
    for (i = 0; i < cartItems.length; i++) {
      if (isFeeLine(cartItems[i])) { if (!feeLine) feeLine = cartItems[i]; }
      else units += unitsOf(cartItems[i]);
    }
    for (i = 0; i < itemsBeingAdded.length; i++) units += unitsOf(itemsBeingAdded[i]);
    var want = !!wantRush || !!feeLine;      /* presence keeps it priced (anti-gaming) */
    var t = want ? tierFor(units) : null;
    var feeKey = feeLine ? (feeLine.key || String(feeLine.id || '')) : null;
    if (!t) return { addVariantId: null, removeLineKey: feeKey };   /* incl. zero units */
    if (feeLine && Number(feeLine.variant_id) === t.vid && (feeLine.quantity || 1) === 1)
      return { addVariantId: null, removeLineKey: null };
    return { addVariantId: t.vid, removeLineKey: feeKey };          /* remove-then-add */
  }

  /* -------- side-effect layer (debounced; sequenced remove->add) -------- */
  var _busy = false, _again = false, _t = null;
  function reconcile() {
    clearTimeout(_t);
    _t = setTimeout(_reconcileNow, 650);      /* debounce: cart APIs 429 on bursts */
  }
  function _reconcileNow() {
    if (_busy) { _again = true; return; }
    _busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var plan = rushPlan(c.items, [], !!window.vaPriority);
        var q = Promise.resolve();
        if (plan.removeLineKey) q = q.then(function () {
          return fetch('/cart/change.js', { method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: plan.removeLineKey, quantity: 0 }) });
        });
        if (plan.addVariantId) q = q.then(function () {
          return fetch('/cart/add.js', { method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: plan.addVariantId, quantity: 1 }] }) });
        });
        if (plan.removeLineKey || plan.addVariantId) q = q.then(function () {
          try { document.dispatchEvent(new CustomEvent('varush:changed')); } catch (_) {}
        });
        return q;
      })
      .catch(function () {})
      .then(function () {
        _busy = false;
        if (_again) { _again = false; reconcile(); }
      });
  }

  /* fetch hook: any successful cart write from ANY surface re-tiers the fee.
     Guard against reacting to our own fee writes (infinite loop) via a marker. */
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url) || '';
    var p = _origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)\.js/.test(url)) {
      var body = init && typeof init.body === 'string' ? init.body : '';
      var isFeeWrite = false;
      for (var vid in FEE_VIDS) if (body.indexOf(vid) > -1) isFeeWrite = true;
      if (!isFeeWrite) p.then(function (r) { if (r && r.ok) reconcile(); return r; });
    }
    return p;
  };

  /* live price for checkbox cards: cart units + the surface's current
     selection (selUnits). Cached cart read, 20s. */
  var _cartCache = { t: 0, units: 0 };
  function cartUnits() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var u = 0;
        (c.items || []).forEach(function (it) { if (!isFeeLine(it)) u += unitsOf(it); });
        _cartCache = { t: Date.now(), units: u };
        return u;
      }).catch(function () { return _cartCache.units; });
  }
  function priceFor(selUnits) {
    var go = (Date.now() - _cartCache.t < 20000)
      ? Promise.resolve(_cartCache.units) : cartUnits();
    return go.then(function (cu) {
      var t = tierFor(cu + Math.max(0, selUnits || 0));
      return t ? { price: t.price, label: t.label } : null;
    });
  }

  if (/^\/cart\/?$/.test(location.pathname)) {
    /* cart page: reconcile on load too (stale fee from an older session) */
    if (document.readyState === 'loading')
      document.addEventListener('DOMContentLoaded', reconcile);
    else reconcile();
  }

  return { rushPlan: rushPlan, unitsOf: unitsOf, tierFor: tierFor,
           reconcile: reconcile, priceFor: priceFor, TIERS: TIERS };
})();
